import Head from 'next/head'
import { CREATE_SUB_MENU, ROUTES } from '../constants/navigation'
import { withHeaderOptions } from '../hoc/withHeaderOptions'
import AIStudio from '../routes/AIStudio'
import { addDisableOverscroll, addRouteType, addSecondaryMenu } from '../utils/navigation'

const AIStudioPage = () => {
  const title = 'AI Interior Designer for Real Rooms | DecorMatters'
  const description =
    "Create, edit, and refine real room designs with DecorMatters' AI interior designer. Upload your room, choose styles and materials, and generate realistic designs on iOS, Android, and web."
  const canonicalUrl = 'https://decormatters.com/ai-interior-design-app'

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <AIStudio />
    </>
  )
}

export default withHeaderOptions(AIStudioPage)(addSecondaryMenu(CREATE_SUB_MENU), addRouteType(ROUTES.HOMEPAGE), addDisableOverscroll())
